import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { setSnackbar } from "reduxStore/state";

const SnackbarComponent = () => {
  const dispatch = useDispatch();

  const snackbar = useSelector((state) => state.snackbar);

  const handleClose = () => {
    dispatch(
      setSnackbar({
        open: false,
        message: "",
        severity: "error",
      })
    );
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        variant="filled"
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;
